import type { MessageTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const messageDark: MessageTheme = {
  name: 'Message',
  common: commonDark,
  self
}

export default messageDark
